/*
  Port of Prestige's CollectionBanner reveal (theme "50", 192185991444, js/sections/collection.js):
  the banner stays hidden (opacity 0, see collection-banner.css) until it scrolls into view AND
  its image has fully loaded, then the image fades in while zooming from scale(1.2) to scale(1).
  Waiting for the full load is the point: without it the browser paints the big banner image
  piece by piece while it downloads, which reads as a half-cut / slow image.
  Timings and easings copied 1:1 from the original motion timeline.
*/
(() => {
  if (customElements.get('collection-banner')) return;

  const EASE_OUT_QUAD = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
  const EASE_OUT_CUBIC = 'cubic-bezier(0.215, 0.61, 0.355, 1)';

  const imageLoaded = (img) =>
    !img || (img.complete && img.naturalWidth > 0)
      ? Promise.resolve()
      : new Promise((resolve) => {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });

  class CollectionBanner extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('reveal-on-scroll')) return;
      if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;

      this._observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this._observer.disconnect();
        this.reveal();
      });
      this._observer.observe(this);
    }

    disconnectedCallback() {
      this._observer?.disconnect();
    }

    async reveal() {
      const image = this.querySelector('.iwto > picture img');
      const content = this.querySelector('.iwto__content-cell');

      await imageLoaded(image);

      this.style.opacity = '1';

      image?.animate(
        { opacity: [0, 1], transform: ['scale(1.2)', 'scale(1)'] },
        { duration: 800, delay: 250, easing: EASE_OUT_QUAD, fill: 'both' }
      );

      // Original: content starts 0.4s before the image animation ends (0.25 + 0.8 - 0.4 = 0.65s).
      content?.animate(
        { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
        { duration: 600, delay: 650, easing: EASE_OUT_CUBIC, fill: 'both' }
      );
    }
  }

  customElements.define('collection-banner', CollectionBanner);
})();
